import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { InviteRepository } from '@efficiently/client-api-invite';

import { InviteGqlRepository } from './repositories/invite-gql.repository';

export function provideInviteDataAccess(): EnvironmentProviders {
	return makeEnvironmentProviders([{ provide: InviteRepository, useClass: InviteGqlRepository }]);
}
